import { getLocale } from '../../util/locales/locales';
import { defaultLocale, getAvailableLocales } from '../../util/locales/available-locales';

import PhraseInContextEditorPostProcessor from 'i18next-phrase-in-context-editor-post-processor';
import Backend from 'i18next-http-backend/cjs';
import { BackendOptions } from 'i18next-http-backend';
import { UserConfig } from 'next-i18next';
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

export const i18n = {
  defaultLocale: defaultLocale.toString(),
  locales: getAvailableLocales('stihlId'),
};

const sharedConfig = {
  lowerCaseLng: true,
  defaultNS: process.env.NEXT_PUBLIC_TRANSLATION_DEFAULT_NAMESPACE!,
  ns: process.env.NEXT_PUBLIC_TRANSLATION_NAMESPACES?.split(',') || [process.env.NEXT_PUBLIC_TRANSLATION_DEFAULT_NAMESPACE!],
  backend: {
    loadPath: `${process.env.NEXT_PUBLIC_TRANSLATION_PATH}/{{ns}}/locales/{{lng}}/translations.json`,
    allowMultiLoading: true,
  } as BackendOptions,
};

export const nextI18nConfig = (serverSide = false) => {
  const usePlugins = [Backend];
  const postProcess: string[] = [];
  const phraseProjectId = process.env.NEXT_PUBLIC_PHRASE_PROJECT_ID;
  const isPhraseActive = typeof window !== 'undefined' && window.localStorage.getItem('PHRASE_INCONTEXT_EDITOR_ACTIVE') !== null;
  if (!serverSide && phraseProjectId && isPhraseActive) {
    usePlugins.push(
      new PhraseInContextEditorPostProcessor({
        phraseEnabled: true,
        projectId: phraseProjectId!,
        autoLowercase: false,
        sso: {
          enabled: true,
          identifier: 'andreas-stihl-ag-co-kg',
          provider: 'saml',
          enforced: false,
        },
      })
    );
    postProcess.push('phraseInContextEditor');
  }

  return {
    i18n: {
      ...i18n,
    },
    use: usePlugins,
    ...sharedConfig,
    debug: false,
    serializeConfig: false,
    postProcess,
    compatibilityJSON: 'v3', // Our Phrase projects are exporting to JSON v3
  } as UserConfig;
};

export const i18nClient = () =>
  i18next
    .use(Backend)
    .use(initReactI18next)
    .init({
      ...sharedConfig,
      returnNull: false,
      lng: getLocale().toString(),
      fallbackLng: 'en-us',
      interpolation: {
        escapeValue: false, // not needed for react!!
      },
    });
